import { IMAGES } from "../../constant/Image";
import Button from "../Button/index";
import { FaLinkedin } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { GoArrowRight } from "react-icons/go";

const Footer = () => {
  return (
    <footer>
      <section className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text">
                <h2>
                  Now Here?{" "}
                  <span>
                    Start your <br /> Auction Bid Now.{" "}
                  </span>
                </h2>
              </div>
              <div className="btn-flex">
                <button
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    border: "none",
                    padding: "10px 20px",
                    fontSize: "16px",
                    borderRadius: "5px",
                    backgroundColor: "red",
                    color: "#fff",
                  }}
                >
                  How To Bid{" "}
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 100 100"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <line
                      x1="25"
                      y1="25"
                      x2="75"
                      y2="75"
                      stroke="#ffffff"
                      strokeWidth="8"
                    ></line>
                    <line
                      x1="75"
                      y1="40"
                      x2="75"
                      y2="75"
                      stroke="#ffffff"
                      strokeWidth="8"
                    ></line>
                    <line
                      x1="40"
                      y1="75"
                      x2="75"
                      y2="75"
                      stroke="#ffffff"
                      strokeWidth="8"
                    ></line>
                  </svg>
                </button>

                <button
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    border: "none",
                    padding: "10px 20px",
                    fontSize: "16px",
                    borderRadius: "5px",
                    backgroundColor: "white",
                    color: "red",
                  }}
                >
                  How To Sell{" "}
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 100 100"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <line
                      x1="25"
                      y1="25"
                      x2="75"
                      y2="75"
                      stroke="#ff0000"
                      strokeWidth="8"
                    ></line>
                    <line
                      x1="75"
                      y1="40"
                      x2="75"
                      y2="75"
                      stroke="#ff0000"
                      strokeWidth="8"
                    ></line>
                    <line
                      x1="40"
                      y1="75"
                      x2="75"
                      y2="75"
                      stroke="#ff0000"
                      strokeWidth="8"
                    ></line>
                  </svg>
                </button>
              </div>
              <div className="girl-and-arrow-imgs">
                <img
                  className="footer_top_arrow"
                  src={IMAGES.footer_top_arrow}
                  alt=""
                />
                <img
                  className="footer_top_girl"
                  src={IMAGES.footer_top_girl}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="main-footer"  style={{
                backgroundImage: `url(${IMAGES.footer_bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }} >
        <div className="container">
          <div className="row">
            <div className="align-boxes-three">
              <div className="box box-01">
                <div className="two-footer-links-align">
                  <div className="inner-box">
                    <div className="text">
                      <h6>Category</h6>
                      <ul>
                        <li>
                          <a href="/">Mercedes</a>
                        </li>
                        <li>
                          <a href="/">Land Rover</a>
                        </li>
                        <li>
                          <a href="/">Chevrolet</a>
                        </li>
                        <li>
                          <a href="/">Nissan Rogue</a>
                        </li>
                        <li>
                          <a href="/">Hyundai</a>
                        </li>
                        <li>
                          <a href="/">Toyota Camry</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="inner-box">
                    <div className="text">
                      <h6>Company</h6>
                      <ul>
                        <li>
                          <a href="/">How to bid with us</a>
                        </li>
                        <li>
                          <a href="/">How to sell with us</a>
                        </li>
                        <li>
                          <a href="/">About Us</a>
                        </li>
                        <li>
                          <a href="/">F.A.Q</a>
                        </li>
                        <li>
                          <a href="/">Our Brand</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="box box-02">
                <a className="footer-logo-link" href="#">
                  <img src={IMAGES.Header_Logo} alt="" />
                  <div className="header-text">
                    <h4>
                      Car <span>Auction</span>
                    </h4>
                  </div>
                </a>

                <div className="text">
                  <h5>Social Just You Connected Us!</h5>
                  <p>All of update in social</p>
                </div>
                <div className="social-links">
                  <ul>
                    <li>
                      <a href="/">
                        <FaLinkedin />
                        Linkedin
                      </a>
                    </li>
                    <li>
                      <a href="/">
                        <FaFacebook />
                        Facebook
                      </a>
                    </li>
                    <li>
                      <a href="/">
                        <FaXTwitter />
                        Twitter
                      </a>
                    </li>
                    <li>
                      <a href="/">
                        <FaInstagram />
                        Instagram
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="box box-03">
                <div className="text">
                  <h3>Join Our Newsletter & More information.</h3>
                </div>
                <form action="">
                  <input type="email" placeholder="Email Address" />
                  <button type="submit" ><GoArrowRight /></button>
                </form>
                <div className="payment-box">
                  <p>Secured Payment Gateways</p>
                  <img src={IMAGES.payment_img} alt="" />
                </div>
              </div>
            </div>
            <div className="bottom-copyright">
              <div className="copy-quick-links-align">
                <p>©Copyright 2025  <span>Auction </span>  |  All rights reserved. </p>
                <ul>
                  <li><a href="/">Support Center</a></li>
                  <li><a href="/">Terms & Conditions</a></li>
                  <li><a href="/">Privacy Policy</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
